export default __webpack_public_path__ + "03ee8b2292791707ebe73ec5237e5bee.png";